module.exports = __webpack_public_path__ + "img/adelphi-logo.27e5a4cf.png";